import { useLocation, NavLink } from 'react-router';
import { NAVIGATION } from '../../types/enum';
import { ReactComponent as ChallengeSvg } from '../../assets/svg/challenge.svg';
import { ReactComponent as CompassNavigatorSvg } from '../../assets/svg/compass-navigator.svg';
import { ReactComponent as CalendarSvg } from '../../assets/svg/calendar.svg';
import { ReactComponent as DishSvg } from '../../assets/svg/dish.svg';
import { ReactComponent as DashboardSvg } from '../../assets/svg/warp-twist.svg';

const navigation = [
  {
    name: NAVIGATION.CHALLENGE,
    icon: <ChallengeSvg className='size-5' />,
    link: '/challenge',
  },
  {
    name: NAVIGATION.HUB,
    icon: <CompassNavigatorSvg className='size-5' />,
    link: '/hub',
  },
  {
    name: NAVIGATION.DASHBOARD,
    icon: <DashboardSvg className='size-5' />,
    link: '/dashboard',
  },
  {
    name: NAVIGATION.WORKOUT_TRACKER,
    icon: <CalendarSvg className='size-5' />,
    link: '/workout',
  },
  {
    name: NAVIGATION.MEAL_TRACKER,
    icon: <DishSvg className='size-5' />,
    link: '/meal',
  },
];

const BottomNav = ({ handleCurrentNav }) => {
  const location = useLocation();

  return (
    <div className='fixed bottom-4 left-[50%] z-40 bg-gray-300/30 rounded-full translate-x-[-50%] p-1 backdrop-blur-sm'>
      <div className='flex justify-center h-full max-w-lg mx-auto font-medium gap-5'>
        {navigation.map((nav) => (
          <NavLink
            key={nav.name}
            to={nav.link}
            onClick={handleCurrentNav(nav.name)}
            className={`p-3 flex items-center justify-center ${
              location.pathname.includes(nav.link) ||
              (location.pathname === '/' && nav.link === '/dashboard')
                ? 'bg-black rounded-full text-white'
                : 'text-gray-400'
            }`}
          >
            {nav.icon}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default BottomNav;
